import { Injectable } from '@angular/core';
import Swal, { SweetAlertIcon } from 'sweetalert2';

export interface AlertConfirmOptions {
  confirmButtonText?: string;
  cancelButtonText?: string;
  icon?: SweetAlertIcon;
}

@Injectable()
export class AlertDialogService {
  private readonly confirmButtonColor = '#0082CA';

  async alert(message: string, title: string = '', icon: SweetAlertIcon = 'info'): Promise<void> {
    await Swal.fire({
      title: title || undefined,
      text: message,
      icon,
      confirmButtonText: 'OK',
      confirmButtonColor: this.confirmButtonColor,
      allowOutsideClick: false,
      allowEscapeKey: true
    });
  }

  async confirm(
    message: string,
    title: string = 'Confirm',
    options?: AlertConfirmOptions
  ): Promise<boolean> {
    const result = await Swal.fire({
      title: title || 'Confirm',
      text: message,
      icon: (options && options.icon) || 'question',
      showCancelButton: true,
      confirmButtonText: (options && options.confirmButtonText) || 'OK',
      confirmButtonColor: this.confirmButtonColor,
      cancelButtonText: (options && options.cancelButtonText) || 'Cancel',
      reverseButtons: true,
      allowOutsideClick: false,
      allowEscapeKey: true,
      focusCancel: true
    });
    return !!result.isConfirmed;
  }
}
